export const payoutConfig: DataViewConfig = {
    items: [
        {
            title: 'Amount',
            field: 'amount',
            dataType: 'amount'
        },
        {
            title: 'Status',
            field: 'status',
            dataType: 'text'
        },
        {
            title: 'Date Created',
            field: 'createdAt',
            dataType: 'date'
        },
        {
            title: 'Date Paid',
            field: 'paidAt',
            dataType: 'date'
        },
    ]
}